// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBMHhIZlTwYKKK3pSwCoCkWaukGipatrW0",
  authDomain: "fireworkweb-cc602.firebaseapp.com",
  projectId: "fireworkweb-cc602",
  storageBucket: "fireworkweb-cc602.firebasestorage.app",
  messagingSenderId: "1008587863296",
  appId: "1:1008587863296:web:1ca1d1a5cb29999689afe5",
  measurementId: "G-5EL32CJTPQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);
auth.useDeviceLanguage(); // Set language automatically

export { storage, auth, RecaptchaVerifier, signInWithPhoneNumber };


